import TambahSOSPK from './TambahSOSPK';

export default TambahSOSPK